export const findSelectedTeamByCountry = (teams, selectedTeam) =>
  (selectedTeam && teams.find(({ code }) => code === selectedTeam.code)) || teams[0];
